// * {
//   padding: 0;
//   margin: 0;
//   text-decoration: none;
//   list-style-type: none;
//   box-sizing: border-box;
// }
import { StyleSheet } from "aphrodite";
import { after } from "lodash";

const styles = StyleSheet.create({
  buttonLogout: {
    float: "left",
    marginLeft: "35px",
    marginTop: "7px",
  },
  imageUser: {
    float: "right",
    minWidth: "290px",
    marginTop: "2px",
  },
  barWhite: {
    marginRight: "30px",
    borderLeft: "2px solid #fff",
  },
  divIcons: {
    float: "right",
    marginTop: "8px",
    marginRight: "30px",
  },
  divIconsPatient: {
    float: "right",
    marginTop: "10px",
  },
  divInformation: {
    float: "left",
    marginTop: "4px",
    marginLeft: "60px",
  },
  iconsMenu: {
    color: "#fff",
    fontSize: "20px",
    marginRight: "30px",
    cursor: "pointer",
  },
  menuActive: {
    borderColor: "#fff",
  },
  imageiconsMenu: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
    borderBottom: "2px solid transparent",
    marginTop: "2px",
    objectFit: "contain",
  },
  connectedDeviceIcon: {
    color: "#fff",
    cursor: "pointer",
    width: "22px",
    height: "22px",
    display: "block",
    flexShrink: 0,
  },
  name: {
    fontSize: "16px",
    marginBottom: "5px",
    color: "#fff",
    marginTop: "4px",
    float: "left",
  },
  role: {
    fontSize: "14px",
    color: "#fff",
  },
  last: {
    color: "#fff",
    fontSize: "12px",
    fontStyle: "italic",
  },
  avatar: {
    height: "44px",
    width: "44px",
    borderRadius: "50%",
    display: "inline-block",
    verticalAlign: "middle",
    marginRight: "9px",
    float: "left",
    border: "2px solid #fff",
  },
  time: {
    display: "inline-block",
    fontSize: "1.231em",
    fontWeight: "400",
    marginRight: "12px",
    verticalAlign: "bottom",
  },
  robotoType: {
    fontFamily: "Roboto",
  },
  timeSpan: {
    display: "block",
    fontSize: "0.679em",
    fontWeight: "600",
    margin: "-12px 0 7px",
  },
  username: {
    display: "inline-block",
    fontSize: "16px",
    lineHeight: "35px",
    verticalAlign: "middle",
  },
  nameUser: {
    color: "#fff",
    fontSize: "26px",
    float: "left",
    textTransform: "uppercase",
    marginTop: "6px",
  },
  genderUser: {
    color: "#fff",
    fontSize: "16px",
    float: "left",
    marginLeft: "30px",
    marginTop: "13px",
  },
  birth: {
    color: "#fff",
    fontSize: "16px",
    float: "left",
    marginLeft: "30px",
    marginTop: "13px",
  },
  divClient: {
    backgroundColor: "#FFF",
    padding: "5px",
    position: "absolute",
    zIndex: "1",
    minWidth: "250px",
    boxShadow: "0px 0px 5px 1px rgba(0,0,0,0.1)",
    top: "29px",
  },
  divClientRelative: {
    position: "relative",
    display: "inline-block",
  },
  lineClient: {
    padding: "10px 5px",
    textTransform: "uppercase",
    cursor: "pointer",
    fontSize: "12px",
    ":hover": {
      backgroundColor: "#eeeeee",
      cursor: "pointer",
    },
  },
  dropdownMenu: {
    left: "-65px !important",
  },
  dropdownItem: {
    ":hover": {
      backgroundColor: "lightblue",
    },
  },
  menu: {
    boxShadow: "none",
    borderRadius: 0,
    border: "none",
    height: "83px",
    "@media (max-width: 575.98px)": {
      height: "auto",
      minHeight: "83px",
    },
  },
  heightPage: {
    minHeight: "calc(100vh - 127px)",
    backgroundColor: "#F2F2F2",
    paddingBottom: "30px"
  },
  menuRight: {
    background: "linear-gradient(to right, #fff 0%, #3f82da 10%, #00c7fa 100%)",
    width: "100%",
    textAlign: "right",
    paddingRight: "10px"
  },
  w100: {
    width: "100%"
  },
  logo: {
    marginTop: "10px"
  },
  nullRightPadding: {
    paddingRight: "0"
  },
  menuItem: {
    textAlign: "left",
    ":before": {
      display: "none"
    },
    ":hover": {
      background: "transparent"
    }
  },
  itensMenu: {
    float: "right",
    minWidth: "300px",
    marginTop: "6px"
  },
  allPatientButtonContainer: {
    width: "19.9%"
  },
  button: {
    borderRadius: "5px",
    width: "40px",
    height: "35px",
    border: "1px solid #01579B",
    boxShadow: "none",
    color: "#01579B"
  },
  // buttonStyle: {
  //   marginLeft: "20px",
  // },
  buttonStyle: {
    marginLeft: "10px",
    ":focus": {
      boxShadow: "none"
    }
  },
  toggleStyle: {
    paddingRight: "0px",
    fontSize: "20px",
    paddingTop: "20px",
    ":focus": {
      boxShadow: "none"
    },
    "@media (max-width: 991.98px)": {
      paddingTop: "0px",
      display: "flex",
      alignItems: "center",
    },
  },
  logoStyle: {
    width: "250px",
    maxWidth: "100%",
    padding: "15px 0px 0px 10px",
    "@media (max-width: 991.98px)": {
      width: "200px",
      padding: "0px 0px 0px 10px",
    },
    "@media (max-width: 575.98px)": {
      width: "180px",
      padding: "0px 0px 0px 6px",
    },
  },
  footer: {
    backgroundColor: "#ffffff",
    boxShadow: "0px -2px 7px -2px rgba(189,182,189,1)",
    paddingTop: "7px",
    color: "#5d5d5d",
    paddingBottom: "5px",
    paddingLeft: "15px",
    paddingRight: "15px"
  },
  textRight: {
    textAlign: "right",
    fontStyle: "italic"
  },
  footerLogo: {
    width: "220px",
    marginTop: "-10px",
    marginLeft: "14px"
  },
  header: {
    backgroundImage: "linear-gradient(to right, #fff 15%, #3f82da 25%, #00c7fa 100%) !important",
    padding: "8px",
    "@media (max-width: 991.98px)": {
      padding: "0 8px",
    },
  },
  navLink: {
    paddingRight: "1.2rem",
    //paddingLeft: "1.2rem"
  },
  subsWrapper1: {
    borderRight: "1px solid black",
    display: "flex",
    alignItems: "center",
    paddingLeft: "1.2em",
    paddingRight: "1em"
  },
  subsWrapperCompact: {
    alignItems: "center",
    paddingLeft: "0.25em",
    paddingRight: "0.25em",
    flexShrink: 0,
  },
  subsWrapper2: {
    position: "relative",
    border: "1px solid #ffc107",
    borderRadius: "25px",
    fontSize: "14px",
    fontWeight: "500",
    backgroundColor: "#f5cf5b",
    padding: "12px",
    textTransform: "uppercase",
    textAlign: "center"
  },
  subsWrapperDropdown: {
    width: "100%",
    textTransform: "none",
    borderRadius: "10px",
    padding: "10px 12px",
    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.08)",
  },
  subsPlanName: {
    fontSize: "13px",
    fontWeight: "600",
    lineHeight: "1.2",
    textTransform: "uppercase",
  },
  subsDateLine: {
    fontSize: "11px",
    fontWeight: "500",
    lineHeight: "1.3",
    textTransform: "none",
    whiteSpace: "nowrap",
    marginTop: "2px",
  },
  profileToggle: {
    padding: "0",
    border: "none",
    boxShadow: "none",
    lineHeight: 1,
    ":focus": {
      boxShadow: "none"
    },
    ":active": {
      boxShadow: "none"
    }
  },
  avatarCompact: {
    height: "40px",
    width: "40px",
    borderRadius: "50%",
    border: "2px solid #fff",
    display: "block",
  },
  circle: {
    position: "absolute",
    top: "-3px",
    right: "0px",
    width: "15px",
    height: "15px",
    webkitBorderRadius: "25px",
    mozBorderRadius: "25px",
    borderRadius: "25px",
   // background: "#10ff10"
  },
});


export default styles;





